var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.875 21C17.8417 21 15.8208 20.5 13.8125 19.5C11.8042 18.5 10 17.2 8.4 15.6C6.8 14 5.5 12.1958 4.5 10.1875C3.5 8.17917 3 6.15833 3 4.125C3 3.80357 3.10714 3.53571 3.32142 3.32142C3.53571 3.10714 3.80357 3 4.125 3H7.625C7.85185 3 8.0544 3.07917 8.23265 3.2375C8.41088 3.39583 8.525 3.60833 8.575 3.875L9.25 7.025C9.28333 7.25833 9.27917 7.47083 9.2375 7.6625C9.19583 7.85417 9.10833 8.01667 8.975 8.15L6.475 10.675C7.40833 12.225 8.45417 13.575 9.6125 14.725C10.7708 15.875 12.0833 16.85 13.55 17.65L15.925 15.2C16.0917 15.0167 16.2833 14.8875 16.5 14.8125C16.7167 14.7375 16.9333 14.725 17.15 14.775L20.125 15.425C20.3802 15.4812 20.5898 15.6078 20.7539 15.8047C20.918 16.0016 21 16.2333 21 16.5V19.875C21 20.1964 20.8929 20.4643 20.6786 20.6786C20.4643 20.8929 20.1964 21 19.875 21ZM5.725 9.3L7.75 7.25L7.175 4.5H4.5C4.5 5.15 4.6 5.8625 4.8 6.6375C5 7.4125 5.30833 8.3 5.725 9.3ZM14.95 18.375C15.6333 18.6917 16.375 18.95 17.175 19.15C17.975 19.35 18.75 19.4667 19.5 19.5V16.825L16.925 16.3L14.95 18.375Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.eacd34d2e93001924b486aabc879ed0f.svg";
export { ForwardRef as ReactComponent };